/**
 * cart-count.js — keeps the header cart bubble in sync without a full reload.
 *
 * Covers:
 *  1. Standard "Add to cart" form submits (product page, quick-add).
 *  2. Cart page quantity changes and remove buttons.
 *  3. Any code that dispatches a custom "cart:updated" event on document.
 *  4. Shopify section re-renders (shopify:section:load).
 */
(function () {
  'use strict';

  /** Fetch the current cart count from the Shopify AJAX API */
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () { /* silently ignore network errors */ });
  }

  /** Update every cart-count element in the DOM */
  function setCount(count) {
    document.querySelectorAll('.hdr__cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('aria-label', count + ' item' + (count !== 1 ? 's' : '') + ' in cart');
      el.style.display = count > 0 ? '' : 'none';
    });

    /* Also update any legacy .header__cart-count elements */
    document.querySelectorAll('.header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /** Intercept a form submission and refresh count after Shopify responds */
  function interceptForm(form) {
    if (form.getAttribute('data-cart-intercepted')) return;
    form.setAttribute('data-cart-intercepted', '1');

    form.addEventListener('submit', function (e) {
      var action = form.getAttribute('action') || '';
      /* Only intercept add-to-cart or cart update forms */
      if (action.indexOf('/cart/add') === -1 &&
          action.indexOf('/cart') === -1 &&
          form.id !== 'cart-form') return;

      /* Let the form submit normally but poll after a short delay */
      setTimeout(refreshCount, 400);
      setTimeout(refreshCount, 1200); /* second pass in case of slow networks */
    });
  }

  /** Hook "Remove" links and quantity inputs in the cart form */
  function bindCartPage() {
    /* Quantity inputs — refresh on change */
    document.querySelectorAll('.cart-form [name="updates[]"], .cart-form [name^="updates"]').forEach(function (input) {
      if (input.getAttribute('data-cart-bound')) return;
      input.setAttribute('data-cart-bound', '1');
      input.addEventListener('change', function () {
        setTimeout(refreshCount, 600);
      });
    });

    /* Remove buttons */
    document.querySelectorAll('[data-cart-remove], .cart-item__remove').forEach(function (btn) {
      if (btn.getAttribute('data-cart-bound')) return;
      btn.setAttribute('data-cart-bound', '1');
      btn.addEventListener('click', function () {
        setTimeout(refreshCount, 600);
        setTimeout(refreshCount, 1400);
      });
    });
  }

  function init() {
    /* Intercept all existing cart/product forms */
    document.querySelectorAll('form[action*="/cart"]').forEach(interceptForm);

    bindCartPage();

    /* Listen for custom event any section can dispatch */
    document.addEventListener('cart:updated', refreshCount);

    /* Observe DOM for new forms added dynamically (quick-add drawers, etc.) */
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('form[action*="/cart"]')) {
              interceptForm(node);
            }
            node.querySelectorAll && node.querySelectorAll('form[action*="/cart"]').forEach(interceptForm);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Re-bind after Shopify theme editor reloads a section */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('form[action*="/cart"]').forEach(interceptForm);
    bindCartPage();
  });
}());
